import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import { Link } from 'react-router-dom';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import VideoDialog from '../../components/modals/VideoDialog';
import defaultImage from '../../assets/images/default/list_box.jpg';
import platBtnImg from '../../assets/images/play.svg';
// import videoDefaultImage from '../../assets/images/default/video-default.jpg';

const ReviewImages = (props) => {
    
    const [url, setUrl] = useState("");
    const [open, setOpen] = useState(false);
    const [gallery, setGallery] = useState([]);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [dialogIsOpen, setDialogIsOpen] = useState(false);

    const handleDialogClose = () => {
        setUrl("")
	    setDialogIsOpen(false)
	}

    const onModalOpen = (videoUrl) => {
        setDialogIsOpen(true)
        setUrl(videoUrl)
    }

    useEffect(() => {
        if(props.images.length > 0) {
            props.images.map((img) => {
                if(img.type.startsWith('image')) {
                    gallery.push(img.src)
                }
            })    
        }
    }, [props.galleries]);

    function addDefaultSrc(e) {
        e.target.src = defaultImage;
    }

    return (
        <>
            <div className="review-images">
                {props.images.map((image, index) => (
                    <Link
                        key={index}
                        to="#"
                        className="image-popup"
                    >
                        {image.type.startsWith('image') && (
                            <>
                                <img 
                                    src={image.src} 
                                    alt="mulk.pk"
                                    onError={addDefaultSrc}
                                />
                                <span  
                                    className="gal-link popup-image"
                                    onClick={() => {
                                        setPhotoIndex(index)
                                        setOpen(true)
                                    }}
                                >
                                    <i className="fa fa-search"></i>
                                </span>
                            </>
                        )}
                        {image.type.startsWith('video') && (
                            <>
                                <video 
                                    className="image-popup"
                                //    poster={videoDefaultImage}
                                    src={image.src}
                                >
                                    <source 
                                        src={image.src} 
                                        type={image.type}
                                    >
                                    </source>
                                </video> 
                                <button 
                                    className="play-btn"
                                    onClick={() => onModalOpen(image.src)}
                                >
                                    <img src={platBtnImg} alt="Mulk.pk" />
                                </button>
                            </>
                        )}
                    </Link>
                ))}
            </div>
            {gallery && open &&
                <Lightbox
                    mainSrc={gallery[photoIndex]}
                    nextSrc={[(photoIndex + 1) % gallery.length]}
                    prevSrc={gallery[(photoIndex + gallery.length - 1) % gallery.length]}
                    onCloseRequest={() => setOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + gallery.length - 1) % gallery.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % gallery.length)
                    }
                //    loader={<CircularProgress color="secondary" />}
                    clickOutsideToClose={true}
                />
            }
            {url && (
                <VideoDialog 
                    dialogIsOpen={dialogIsOpen} 
                    handleDialogClose={handleDialogClose} 
                    setDialogIsOpen={setDialogIsOpen} 
                    url={url}
                />
            )}
        </>
    );
};

export default ReviewImages;